module.exports = __webpack_public_path__ + "img/memberkit-icon.9a9a3812.svg";